import { Blockchain, BlockchainLxIconSrc, WalletGroup } from '@/constants/blockchain'
import Wallet from '@/models-ts/Wallet'

export function getBlockchainIcon(blockchain: Blockchain) {
  return (BlockchainLxIconSrc as Record<number, string | null | undefined>)[blockchain]
}

export function getWalletIcon(wallet: any): string {
  const group = typeof wallet === 'object' ? wallet.group : wallet
  switch (group) {
    case WalletGroup.Metamask:
      return '/static/images/wallets/metamask-wallet.svg'
    case WalletGroup.WalletConnect:
      return '/static/images/wallets/wallet-connect.png'
    case WalletGroup.TronLink:
      return '/static/images/wallets/tron-wallet.png'
    default:
      return '/static/images/wallets/cloud-wallet.svg'
  }
}

export function getWalletGroupName(wallet: any): string {
  const group = typeof wallet === 'object' ? wallet.group : wallet
  switch (group) {
    case WalletGroup.Metamask:
      return 'Metamask'
    case WalletGroup.WalletConnect:
      return 'WalletConnect'
    case WalletGroup.Cloud:
      return 'Cloud wallet'
    case WalletGroup.TronLink:
      return 'TronLink'
    default:
      return ''
  }
}

export function getFreelancerWalletForContract(wallets: Wallet[], requiredWalletGroup: WalletGroup): Wallet | null {
  const defaultWallet: Wallet = wallets.find((item: Wallet) => item.is_default === 1)!
  return defaultWallet
}
